import { ClipboardCheck, Printer, ListChecks, FileText } from "lucide-react";
import LeadCaptureForm from "./LeadCaptureForm";

const perks = [
  { icon: ListChecks, text: "43 checkboxes across all 9 steps" },
  { icon: Printer, text: "Print it or check it off on your phone" },
  { icon: FileText, text: "Official fees & agencies at a glance" },
];

export default function LeadMagnetSection() {
  return (
    <section id="free-checklist" data-testid="lead-magnet-section" className="border-t-2 border-[var(--c-border)] bg-[#1E3A8A] px-4 py-16 text-white sm:py-20">
      <div className="mx-auto grid max-w-5xl items-center gap-10 lg:grid-cols-[minmax(0,3fr)_minmax(0,2fr)]">
        <div>
          <p className="mb-3 inline-flex items-center gap-2 rounded-full border-2 border-white/40 bg-white/10 px-3 py-1 text-[10px] font-bold uppercase tracking-[0.15em]">
            <ClipboardCheck className="h-3.5 w-3.5" /> Free download
          </p>
          <h2 className="font-heading text-3xl font-black leading-tight sm:text-4xl">
            Get the Texas LLC Startup Checklist — free.
          </h2>
          <p className="mt-4 max-w-xl text-base leading-relaxed text-blue-100">
            The printable 2-page checklist we hand to every founder: every task from picking your name to filing your first franchise tax report, in order. Drop your email and it&apos;s yours in seconds.
          </p>
          <ul className="mt-6 space-y-2.5">
            {perks.map(({ icon: Icon, text }) => (
              <li key={text} className="flex items-center gap-3 text-sm font-medium text-blue-50">
                <span className="flex h-7 w-7 flex-shrink-0 items-center justify-center rounded-lg border-2 border-white/40 bg-white/10"><Icon className="h-3.5 w-3.5" /></span>
                {text}
              </li>
            ))}
          </ul>
        </div>

        <div className="relative">
          <div className="absolute -right-3 -top-3 h-full w-full rounded-3xl bg-[#C8102E]" aria-hidden="true" />
          <div className="relative rounded-3xl border-2 border-[var(--c-border)] bg-[var(--c-surface)] p-6 text-[var(--c-text)] shadow-[6px_6px_0px_var(--c-shadow)]">
            <div className="mb-4 flex items-center gap-3">
              <div className="flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-xl border-2 border-[var(--c-border)] bg-white">
                <img src="/logo-mark.png" alt="" className="h-9 w-9 object-contain" />
              </div>
              <div>
                <p className="font-heading text-base font-black leading-tight">Texas LLC Startup Checklist</p>
                <p className="text-xs text-[var(--c-muted)]">PDF &middot; 2 pages &middot; 9 steps</p>
              </div>
            </div>
            <LeadCaptureForm source="landing_section" />
          </div>
        </div>
      </div>
    </section>
  );
}
